const close = document.getElementById("close-modal-bfm");
const close2 = document.getElementById("modal-video");

const stopVideo = function () {
  const iframe = document.querySelector( 'iframe');
  const iframeSrc = iframe.src;
  iframe.src = iframeSrc;
};

close.addEventListener("click", function(e) {
  stopVideo();
})

close2.addEventListener("click", function(e) {
  stopVideo();
})
